jQuery(document).ready(commonInit);

function commonInit(){
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	setupMobileMenu();
	setupColumns();
	setupSearch();
	setupFancyFocus();
	setupScrollTriggers();
	
}

function setupFancyFocus(){	
	var formElements = jQuery('input, textarea');
	formElements.on('focus', function(){
		jQuery(this).closest(".gfield").addClass('focus');
	});
	formElements.on('blur', function(){
		var listItem = jQuery(this);
		if (!listItem.val()) 
		{
			listItem.closest(".gfield").removeClass('focus');
		}
		
	});
}

function setupMobileMenu(){
	
	jQuery("#mobile-nav").mmenu({
		"slidingSubmenus": false,
		"offCanvas": {
			"position": "top"
		}
	}, {
	
		classNames: {
			selected: "current-menu-item",
			fixedElements: {
				
				fixed: "mobile-sticky"
				
			}
		}
		
	});
	jQuery("#mobile-menu-button").on("click", function(){
		
		if(jQuery("html").hasClass("mm-opened")) {
			var api = jQuery('#mobile-nav').data('mmenu');
			api.close();
		}
		
	});
	
}



function setupColumns(){
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).length;
		
		current.addClass('has-'+columnCount+'-columns');
		
	});
	
}

//usage: var first = getUrlVars()['id'];
function getUrlVars(){
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}
window.getUrlVars = getUrlVars;

function setCookie(cname, cvalue, exdays){
	 
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    
}
window.setCookie = setCookie;

function getCookie(cname){
	
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    
    for(var i = 0; i <ca.length; i++){
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
     
    return ""; 
    
}
window.getCookie = getCookie;


function setupSearch() {
	
	jQuery('.search-button').on('click', function(e){
		
		var html = jQuery('html');
		var searchButton = jQuery(this);
		var isHeader = searchButton.parents('header').length;
		
		if(!html.hasClass('search-open')) {
		
			e.preventDefault();
			
			if(isHeader) {
				html.addClass('search-open-header search-open');
				jQuery('#search-header-desktop').focus();
			} else {
				html.addClass('search-open-footer search-open');
				jQuery('#search-footer').focus();
			}
			
		}
		
	});
	
	jQuery('.search-container form').on('click', function(e){
				
		e.stopPropagation();
		
	});
	
	jQuery('html').on('click', function(e){
		jQuery('html').removeClass('search-open-header search-open-footer search-open');
	});
	
}

function setupScrollTriggers(){

	const elements = document.querySelectorAll('.scroll-alert:not(.set-up)');
	
	if ('IntersectionObserver' in window) {
	
		const options = {
			root: null,
			rootMargin: '0px 0px -10% 0px',
			threshold: 0
		};
		
		var observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if(entry.isIntersecting) {
					entry.target.classList.add('active');
				}
			});
		}, options);
		
		elements.forEach(element => {
			element.classList.add('set-up');
			observer.observe(element);
		});
		
	} else {
		
		for(var i=0; i<elements.length; i++) {
			elements[i].classList.add('set-up');
			elements[i].classList.add('active');	
		}
		
	}

}